<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  import './assets/style/reset.css'
  import './assets/style/common.scss'
  export default {
    name: 'App'
  }
</script>

<style>
  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #333333;
    margin-top: 0px;
    height: 100%;
  }
  html,body{
    height: 100%;
  }

  h1,h2,h3,p{
    padding: 0;
  }
  /* ::-webkit-scrollbar {
    display: none
  } */

</style>



// WEBPACK FOOTER //
// src/App.vue